// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
let __webpack_exports__ = __webpack_require__.O(undefined, [869], () => (__webpack_require__("BdKS")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
